import BaseScenesPermissions from 'models/Permissions/BaseScenesPermissions'

class MultiquoteBicyclePermissions extends BaseScenesPermissions {}

export default MultiquoteBicyclePermissions
